<div [class.fullscreen]="isFullscreen$ | async" class="new-message-container">
	<form [formGroup]="newMessageForm" (ngSubmit)="newMessageForm.valid && onSendMessage()">
		<mat-form-field class="field" appearance="outline" floatLabel="{{ onFloatLabel() }}">
			<mat-label>{{ 'recipients' | translate }}</mat-label>
			<mat-autocomplete
				#auto="matAutocomplete"
				hideSingleSelectionIndicator
				panelWidth="600px"
				class="nice-scroll colored-scroll-track visible-scroll"
			>
				@for (group of contactGroup(); track group.name) {
					@if (
						group.contacts
							| auQuickSearchName
								: newMessageForm.value.recipients
								: ['firstName', 'lastName', 'email'];
						as filteredContacts
					) {
						@if (filteredContacts.length > 0) {
							<mat-optgroup [label]="group.name" class="opt-group">
								@for (contact of filteredContacts; track contact.id) {
									@if (contact.email && !isEmailInRecipients(contact.email)) {
										<mat-option [value]="contact"
											><span class="black-text"
												>{{ contact.firstName }} {{ contact.lastName }} ({{
													contact.email
												}})
											</span></mat-option
										>
									}
								}
							</mat-optgroup>
						}
					}
				}
			</mat-autocomplete>
			<div class="d-flex input-container">
				@for (email of emails(); track email) {
					<span class="removable-contact">
						{{ email.name ? email.name : email.email
						}}<mat-icon (click)="removeContact(email)">close</mat-icon>
					</span>
				}

				<input
					#recipientsInput
					#trigger="matAutocompleteTrigger"
					formControlName="recipients"
					matInput
					type="email"
					(keydown.backspace)="onBackspacePressed()"
					(keydown.escape)="trigger.closePanel()"
					(keydown.enter)="onEnterPressed()"
					[matAutocomplete]="auto"
				/>
			</div>
			@if (emailWarning()) {
				<mat-hint class="email-warning">
					<mat-icon>info</mat-icon
					>{{
						'missing_email_addresses'
							| translate: { count: this.initialContent.missingEmails.toString() }
					}}
				</mat-hint>
			}
			@if (newMessageForm.get('recipients').hasError('required')) {
				<mat-error>
					<span> {{ 'required' | translate }} </span>
				</mat-error>
			}
			@if (newMessageForm.get('recipients').hasError('email')) {
				<mat-error>{{ 'invalid_email' | translate }}. {{ suggestEmail() }}</mat-error>
			}
		</mat-form-field>
		<mat-form-field class="field" appearance="outline">
			<mat-label>{{ 'subject' | translate }}</mat-label>
			<input formControlName="subject" matInput type="text" #subjectInput />
			<mat-error>
				@if (newMessageForm.controls.subject.errors?.required) {
					<span>
						{{ 'required' | translate }}
					</span>
				}
			</mat-error>
			@if (newMessageForm.controls.subject.value) {
				<mat-hint align="end">
					{{ newMessageForm.controls.subject.value.length }} /
					{{ maxSubjectLength }}
				</mat-hint>
			}
		</mat-form-field>
		<mat-form-field appearance="outline">
			<textarea
				class="nice-scroll colored-scroll-track visible-scroll"
				formControlName="text"
				matInput
				placeholder="{{ 'write_message_here' | translate }}"
				type="text"
				cdkTextareaAutosize
				cdkAutosizeMaxRows="15"
				rows="10"
			></textarea>
		</mat-form-field>
	</form>

	<au-file-loader
		[loadedFiles]="newMessageForm?.value?.files"
		[options]="{ fileTypesConfig }"
		[delegateDeleting]="true"
		[askDeleting]="false"
		[fullFileLoadData]="true"
		[cardsView]="true"
		[allowEditFiles]="newMessage"
		(addExistingFileClicked)="navigateToExist($event)"
		(fullFileLoaded)="fileListChanged($event)"
		(filesDeleted)="filesDeleted($event)"
		(rowSelect)="viewSelected($event)"
	></au-file-loader>
	<div class="signature-placeholder">
		<p>{{ 'signature_included_in_email' | translate }}</p>
	</div>
</div>
